"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { EJINSIGHT_COLORS } from "@/lib/theme/ejinsight";

type ArrowButtonProps = {
  direction: "prev" | "next";
  onClick?: () => void;
  ariaLabel?: string;
  disabled?: boolean;
};

export function ArrowButton({
  direction,
  onClick,
  ariaLabel,
  disabled,
}: ArrowButtonProps) {
  const Icon = direction === "prev" ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      aria-label={ariaLabel ?? (direction === "prev" ? "Previous" : "Next")}
      onClick={onClick}
      disabled={disabled}
      className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-all duration-200 hover:scale-105 disabled:cursor-not-allowed disabled:opacity-30"
      style={{
        backgroundColor: EJINSIGHT_COLORS.surface,
        border: `1px solid ${EJINSIGHT_COLORS.hairline}`,
        color: EJINSIGHT_COLORS.ink,
      }}
    >
      <Icon className="h-5 w-5" strokeWidth={2.2} />
    </button>
  );
}
